import { createContext, useContext } from 'react'

// ============================================
// ARTEMIS MODE CONTROL
// Change this value to toggle artemis mode for the entire app
// true = artemis mode active (theme and features enabled)
// false = normal mode (default appearance and features)
// ============================================
const ARTEMIS_MODE_ACTIVE = false

const ArtemisModeContext = createContext(null)

export function ArtemisModeProvider({ children }) {
  const value = {
    isArtemisModeActive: ARTEMIS_MODE_ACTIVE
  }
  
  return (
    <ArtemisModeContext.Provider value={value}>
      {children}
    </ArtemisModeContext.Provider>
  )
}

export function useArtemisMode() {
  const context = useContext(ArtemisModeContext)
  if (!context) {
    throw new Error('useArtemisMode must be used within ArtemisModeProvider')
  }
  return context
}
